import type { SkillCategory, SubCategory } from '../types/userModuleTypes';

export type MachineSuggestOption = { value: string; label: string };

type CompanyUnitRef = { id: string; name?: string | null; categoryId?: string | null };

/** Linked equipment units plus legacy SubCategory labels for a skill category (2C). */
export function getMachineSuggestOptions(
    skillCategory: Pick<SkillCategory, 'id' | 'equipmentCategoryId'> | undefined,
    companyUnits: CompanyUnitRef[],
    subCategories: SubCategory[],
): MachineSuggestOption[] {
    if (!skillCategory) return [];

    const unitOptions: MachineSuggestOption[] = skillCategory.equipmentCategoryId
        ? companyUnits
              .filter((u) => u.categoryId === skillCategory.equipmentCategoryId)
              .map((u) => ({ value: u.id, label: (u.name && u.name.trim()) || u.id }))
        : [];

    const unitIds = new Set(unitOptions.map((o) => o.value));
    const subOptions = subCategories
        .filter((sub) => sub.categoryId === skillCategory.id && !unitIds.has(sub.id))
        .map((sub) => ({ value: sub.id, label: sub.name.trim() || sub.id }));

    return [...unitOptions, ...subOptions].sort((a, b) =>
        a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }),
    );
}
